module.exports = Promise.resolve(module.bundle.root("04S3o"))